// extracted by mini-css-extract-plugin
export default {"regenerate":"AIGenerateButton_regenerate__aiRLu"};